export type TimelineSummaryRenderer = 'vitals' | 'fields'

export interface ITimelineSummaryConfig {
  renderer: TimelineSummaryRenderer
  fields?: string[]
  showLabels?: boolean
}

export const TIMELINE_SUMMARY_CONFIG: Record<string, ITimelineSummaryConfig> = {
  Vitals: { renderer: 'vitals' },
  Cardiac: {
    renderer: 'fields',
    fields: ['Performed By', 'Action', 'Joules', 'Defib Type', 'Type', 'Lead Change', 'Attempts', 'Successful'],
  },
  Intubation: {
    renderer: 'fields',
    fields: ['Performed By', 'Size', 'Distance', 'Attempts', 'Successful'],
  },
  Airway: {
    renderer: 'fields',
    fields: [
      'Performed By',
      'Action',
      'Flow',
      'FiO2',
      'Via',
      'Humidity',
      'Air Temperature',
      'Oral Pharyngeal Airway',
      'Pressure',
      'Inspiratory Pressure',
      'Expiratory Pressure',
      'Attempts',
      'Successful',
    ],
  },
  'Initiate IV': {
    renderer: 'fields',
    fields: ['Performed By', 'Site', 'Gauge', 'Type', 'Attempts', 'Successful'],
  },
  Ventilator: {
    renderer: 'fields',
    fields: ['Performed By', 'Action', 'FiO2', 'Air Temperature'],
  },
  'Medication Administered': {
    renderer: 'fields',
    showLabels: false,
    fields: ['Medication', 'Dose', 'Dose Unit', 'Route'],
  },
  Titrate: {
    renderer: 'fields',
    fields: ['Performed By', 'Medication', 'Route', 'New Dose/Rate', 'Unit'],
  },
  'Medical Consult': {
    renderer: 'fields',
    fields: ['Performed By', 'Physician', 'Method', 'Facility', 'Attempts', 'Successful'],
  },
  Assessments: {
    renderer: 'fields',
    fields: ['Performed By', 'Action'],
  },
  Assessment: {
    renderer: 'fields',
    fields: ['Performed By', 'Action'],
  },
  'Blood Product Administration': {
    renderer: 'fields',
    fields: ['Performed By', 'Blood Product', 'PT. Id Verified'],
  },
  'Childbirth / OB': {
    renderer: 'fields',
    fields: [
      'Performed By',
      'Action',
      'Fetal HR',
      'Contractions Freq',
      'Contractions Dur',
      'Variability',
      'Accelerations',
      'Deceleration',
      'UC Strength',
      'DTR',
      'Attempts',
      'Successful',
    ],
  },
  Childbirth: {
    renderer: 'fields',
    fields: [
      'Performed By',
      'Action',
      'Fetal HR',
      'Contractions Freq',
      'Contractions Dur',
      'Variability',
      'Accelerations',
      'Deceleration',
      'UC Strength',
      'DTR',
      'Attempts',
      'Successful',
    ],
  },
  'Critical Care': {
    renderer: 'fields',
    fields: ['Performed By', 'Action', 'Site'],
  },
  Drain: {
    renderer: 'fields',
    fields: ['Performed By', 'Action', 'Attempts', 'Successful'],
  },
  Extrication: {
    renderer: 'fields',
    fields: ['Performed By', 'Attempts', 'Successful'],
  },
  'Hospital Notify': {
    renderer: 'fields',
    fields: ['Performed By'],
  },
  'Hosp. Notify': {
    renderer: 'fields',
    fields: ['Performed By'],
  },
  'Imaging/Ultrasound': {
    renderer: 'fields',
    fields: ['Performed By', 'Type', 'Location', 'Findings'],
  },
  Immobilization: {
    renderer: 'fields',
    fields: ['Performed By', 'Option', 'Devices Used', 'Assessment', 'Site'],
  },
  Operations: {
    renderer: 'fields',
    fields: ['Performed By', 'Attempts', 'Successful'],
  },
  Rescue: {
    renderer: 'fields',
    fields: ['Performed By'],
  },
  'Ventricular Assist Device': {
    renderer: 'fields',
    fields: ['Performed By', 'Ventricular Assist Device', 'Indication'],
  },
  'Wound Care': {
    renderer: 'fields',
    fields: ['Performed By', 'Attempts', 'Successful'],
  },
}
